import { URL } from "../environment/variables";

export const getInfoTextService = async () => {

    try{
        const response = await fetch(`${URL}/cms/obtenerconfiguraciones/5C9A0574-0D78-4CB0-BAC4-204F9CDBAFDF`, {
            mode: 'cors',
            method: 'GET',
            headers:{
                'Accept': '*/*',
            }
        })
        const json = await response.json()
        return json
    }catch(err){
        console.log(err)
    }

}